import stringsToSymbols from "@/util/strings-to-symbols.mjs";

export const FORTNITE_QUEUES_SYMBOLS = stringsToSymbols([
  "allFortniteQueues",
  "solo",
  "duos",
  "trios",
  "squad",
  "reloadSolo",
  "reloadDuos",
  "reloadTrios",
  "reloadSquad",
  "ogSolo",
  "ogDuos",
  "ogTrios",
  "ogSquads",
  "blitzSolo",
  "blitzDuos",
  "blitzTrios",
  "blitzSquad",
]);

type Queue = {
  key: string;
  internal: string[];
  t: Translation;
  backendKey: string | null;
  dataKey: string;
};

export type Queues = Record<symbol, Queue>;

export const ALL_QUEUE: Queues = {
  [FORTNITE_QUEUES_SYMBOLS.allFortniteQueues]: {
    key: "ALL",
    internal: [],
    t: ["fortnite:queues.all", "All Queues"] as Translation,
    backendKey: null,
    dataKey: "ALL",
  },
};

export const BATTLE_ROYALE_QUEUES: Queues = {
  [FORTNITE_QUEUES_SYMBOLS.solo]: {
    key: "SOLO",
    internal: [
      "Playlist_DefaultSolo",
      "Playlist_NoBuildBR_Solo",
      "Playlist_HabaneroSolo",
      "Playlist_NoBuildBR_Habanero_Solo",
    ],
    t: ["fortnite:queues.solo", "Solo"] as Translation,
    backendKey: "SOLO",
    dataKey: "SOLO",
  },
  [FORTNITE_QUEUES_SYMBOLS.duos]: {
    key: "DUO",
    internal: [
      "Playlist_DefaultDuo",
      "Playlist_NoBuildBR_Duo",
      "Playlist_HabaneroDuo",
      "Playlist_NoBuildBR_Habanero_Duo",
    ],
    t: ["fortnite:queues.duos", "Duos"] as Translation,
    backendKey: "DUO",
    dataKey: "DUO",
  },
  [FORTNITE_QUEUES_SYMBOLS.trios]: {
    key: "TRIO",
    internal: [
      "playlist_trios",
      "Playlist_Trios",
      "Playlist_NoBuildBR_Trio",
      "Playlist_HabaneroTrio",
      "Playlist_NoBuildBR_Habanero_Trio",
    ],
    t: ["fortnite:queues.trios", "Trios"] as Translation,
    backendKey: "TRIO",
    dataKey: "TRIO",
  },
  [FORTNITE_QUEUES_SYMBOLS.squad]: {
    key: "SQUAD",
    internal: [
      "Playlist_DefaultSquad",
      "Playlist_NoBuildBR_Squad",
      "Playlist_HabaneroSquad",
      "Playlist_NoBuildBR_Habanero_Squad",
    ],
    t: ["fortnite:queues.squad", "Squad"] as Translation,
    backendKey: "SQUAD",
    dataKey: "SQUAD",
  },
};

export const RELOAD_QUEUES: Queues = {
  [FORTNITE_QUEUES_SYMBOLS.reloadSolo]: {
    key: "RELOAD_SOLO",
    internal: [
      "Playlist_BlastBerrySolo",
      "Playlist_BlastBerrySolo2",
      "Playlist_BlastBerryNoBuildSolo",
      "Playlist_Habanero_BlastBerry_Solo",
      "Playlist_Habanero_NoBuild_BlastBerry_Solo",
      "Playlist_SunflowerSolo",
      "Playlist_SunflowerNoBuildSolo",
      "Playlist_Habanero_Sunflower_Solo",
      "Playlist_Habanero_NoBuild_Sunflower_Solo",
      "Playlist_PunchBerrySolo",
      "Playlist_PunchBerryNoBuildSolo",
      "Playlist_Habanero_PunchBerry_Solo",
      "Playlist_Habanero_NoBuild_PunchBerry_Solo",
      "Playlist_DashBerrySolo",
      "Playlist_DashBerryNoBuildSolo",
      "Playlist_Habanero_DashBerry_Solo",
      "Playlist_Habanero_NoBuild_DashBerry_Solo",
      "Playlist_TimberStakeSolo",
      "Playlist_TimberStakeNoBuildSolo",
      "Playlist_Habanero_TimberStake_Solo",
      "Playlist_Habanero_NoBuild_TimberStake_Solo",
      "Playlist_Habanero_NoBuild_SourSpawn_Solo",
      "Playlist_Habanero_SourSpawn_Solo",
      "Playlist_SourSpawnNoBuildSolo",
      "Playlist_SourSpawnSolo",
      "Playlist_PiperBootSolo",
      "Playlist_Habanero_PiperBoot_Solo",
      "Playlist_PiperBootNoBuildSolo",
      "Playlist_Habanero_NoBuild_PiperBoot_Solo",
    ],
    t: ["fortnite:queues.solo", "Solo"] as Translation,
    backendKey: "RELOAD_SOLO",
    dataKey: "RELOAD_SOLO",
  },
  [FORTNITE_QUEUES_SYMBOLS.reloadDuos]: {
    key: "RELOAD_DUO",
    internal: [
      "Playlist_BlastBerryDuo",
      "Playlist_BlastBerryNoBuildDuo",
      "Playlist_Habanero_BlastBerry_Duos",
      "Playlist_Habanero_NoBuild_BlastBerry_Duos",
      "Playlist_SunflowerDuo",
      "Playlist_SunflowerNoBuildDuo",
      "Playlist_Habanero_Sunflower_Duos",
      "Playlist_Habanero_NoBuild_Sunflower_Duos",
      "Playlist_PunchBerryDuo",
      "Playlist_PunchBerryNoBuildDuo",
      "Playlist_Habanero_PunchBerry_Duos",
      "Playlist_Habanero_NoBuild_PunchBerry_Duos",
      "Playlist_DashBerryDuo",
      "Playlist_DashBerryNoBuildDuo",
      "Playlist_Habanero_DashBerry_Duos",
      "Playlist_Habanero_NoBuild_DashBerry_Duos",
      "Playlist_TimberStakeDuo",
      "Playlist_TimberStakeNoBuildDuo",
      "Playlist_Habanero_TimberStake_Duos",
      "Playlist_Habanero_NoBuild_TimberStake_Duos",
      "Playlist_Habanero_NoBuild_SourSpawn_Duos",
      "Playlist_Habanero_SourSpawn_Duos",
      "Playlist_SourSpawnDuo",
      "Playlist_SourSpawnNoBuildDuo",
      "Playlist_PiperBootDuo",
      "Playlist_Habanero_PiperBoot_Duos",
      "Playlist_PiperBootNoBuildDuo",
      "Playlist_Habanero_NoBuild_PiperBoot_Duos",
    ],
    t: ["fortnite:queues.duos", "Duos"] as Translation,
    backendKey: "RELOAD_DUO",
    dataKey: "RELOAD_DUO",
  },
  // [FORTNITE_QUEUES_SYMBOLS.reloadTrios]: {
  //   key: "RELOAD_TRIO",
  //   internal: [
  //     "Playlist_BlastBerryTrio",
  //     "Playlist_BlastBerryNoBuildTrio",
  //     "Playlist_SunflowerTrio",
  //     "Playlist_SunflowerNoBuildTrio",
  //     "Playlist_PunchBerryTrio",
  //     "Playlist_PunchBerryNoBuildTrio",
  //     "Playlist_DashBerryTrio",
  //     "Playlist_DashBerryNoBuildTrio",
  //   ],
  //   t: ["fortnite:queues.trios", "Trios"] as Translation,
  //   backendKey: "RELOAD_TRIO",
  //   dataKey: "RELOAD_TRIO",
  // },
  [FORTNITE_QUEUES_SYMBOLS.reloadSquad]: {
    key: "RELOAD_SQUAD",
    internal: [
      "Playlist_BlastBerrySquad",
      "Playlist_BlastBerryNoBuildSquad",
      "Playlist_Habanero_BlastBerry_Squads",
      "Playlist_Habanero_NoBuild_BlastBerry_Squads",
      "Playlist_SunflowerSquad",
      "Playlist_SunflowerNoBuildSquad",
      "Playlist_Habanero_Sunflower_Squads",
      "Playlist_Habanero_NoBuild_Sunflower_Squads",
      "Playlist_PunchBerrySquad",
      "Playlist_PunchBerryNoBuildSquad",
      "Playlist_Habanero_PunchBerry_Squads",
      "Playlist_Habanero_NoBuild_PunchBerry_Squads",
      "Playlist_DashBerrySquad",
      "Playlist_DashBerryNoBuildSquad",
      "Playlist_Habanero_DashBerry_Squads",
      "Playlist_Habanero_NoBuild_DashBerry_Squads",
      "Playlist_TimberStakeSquad",
      "Playlist_TimberStakeNoBuildSquad",
      "Playlist_Habanero_TimberStake_Squads",
      "Playlist_Habanero_NoBuild_TimberStake_Squads",
      "Playlist_Habanero_NoBuild_SourSpawn_Squads",
      "Playlist_Habanero_SourSpawn_Squads",
      "Playlist_SourSpawnNoBuildSquad",
      "Playlist_SourSpawnSquad",
      "Playlist_PiperBootSquad",
      "Playlist_Habanero_PiperBoot_Squads",
      "Playlist_PiperBootNoBuildSquad",
      "Playlist_Habanero_NoBuild_PiperBoot_Squads",
    ],
    t: ["fortnite:queues.reloadSquad", "Squad"] as Translation,
    backendKey: "RELOAD_SQUAD",
    dataKey: "RELOAD_SQUAD",
  },
};

export const OG_QUEUES = {
  [FORTNITE_QUEUES_SYMBOLS.ogSolo]: {
    key: "OG_SOLO",
    internal: [
      "Playlist_FigmentSolo",
      "Playlist_FigmentNoBuildSolo",
      "Playlist_Habanero_Figment_Solo",
      "Playlist_Habanero_NoBuild_Figment_Solo",
    ],
    t: ["fortnite:queues.solo", "Solo"] as Translation,
    backendKey: "OG_SOLO",
    dataKey: "OG_SOLO",
  },
  [FORTNITE_QUEUES_SYMBOLS.ogDuos]: {
    key: "OG_DUO",
    internal: [
      "Playlist_FigmentDuo",
      "Playlist_FigmentNoBuildDuo",
      "Playlist_Habanero_Figment_Duo",
      "Playlist_Habanero_NoBuild_Figment_Duo",
    ],
    t: ["fortnite:queues.duos", "Duos"] as Translation,
    backendKey: "OG_DUO",
    dataKey: "OG_DUO",
  },
  [FORTNITE_QUEUES_SYMBOLS.ogTrios]: {
    key: "OG_TRIO",
    internal: [
      "Playlist_FigmentTrio",
      "Playlist_FigmentNoBuildTrio",
      "Playlist_Habanero_Figment_Trio",
      "Playlist_Habanero_NoBuild_Figment_Trio",
    ],
    t: ["fortnite:queues.trios", "Trios"] as Translation,
    backendKey: "OG_TRIO",
    dataKey: "OG_TRIO",
  },
  [FORTNITE_QUEUES_SYMBOLS.ogSquads]: {
    key: "OG_SQUAD",
    internal: [
      "Playlist_FigmentSquad",
      "Playlist_FigmentNoBuildSquad",
      "Playlist_Habanero_Figment_Squad",
      "Playlist_Habanero_NoBuild_Figment_Squad",
    ],
    t: ["fortnite:queues.squad", "Squad"] as Translation,
    backendKey: "OG_SQUAD",
    dataKey: "OG_SQUAD",
  },
};

export const BLITZ_ROYALE_QUEUES: Queues = {
  [FORTNITE_QUEUES_SYMBOLS.blitzSolo]: {
    key: "BLITZ_SOLO",
    internal: [
      "Playlist_ForbiddenFruitNoBuildBRSolo",
      "Playlist_ForbiddenFruit_CalmSambucusBRSolo",
    ],
    t: ["fortnite:queues.solo", "Solo"] as Translation,
    backendKey: "BLITZ_SOLO",
    dataKey: "SOLO",
  },
  [FORTNITE_QUEUES_SYMBOLS.blitzDuos]: {
    key: "BLITZ_DUO",
    internal: [
      "Playlist_ForbiddenFruitNoBuildBRDuo",
      "Playlist_ForbiddenFruit_CalmSambucusBRDuo",
    ],
    t: ["fortnite:queues.duos", "Duos"] as Translation,
    backendKey: "BLITZ_DUO",
    dataKey: "DUO",
  },
  [FORTNITE_QUEUES_SYMBOLS.blitzTrios]: {
    key: "BLITZ_TRIO",
    internal: ["Playlist_ForbiddenFruitNoBuildBRTrio"],
    t: ["fortnite:queues.trios", "Trios"] as Translation,
    backendKey: "BLITZ_TRIO",
    dataKey: "TRIO",
  },
  [FORTNITE_QUEUES_SYMBOLS.blitzSquad]: {
    key: "BLITZ_SQUAD",
    internal: [
      "Playlist_ForbiddenFruitNoBuildBRSquad",
      "Playlist_ForbiddenFruit_CalmSambucusBRSquad",
    ],
    t: ["fortnite:queues.squad", "Squad"] as Translation,
    backendKey: "BLITZ_SQUAD",
    dataKey: "SQUAD",
  },
};

export const FORTNITE_QUEUES: Queues = {
  ...ALL_QUEUE,
  ...BATTLE_ROYALE_QUEUES,
  ...RELOAD_QUEUES,
  ...OG_QUEUES,
  ...BLITZ_ROYALE_QUEUES,
};

export const FORTNITE_QUEUES_BE: string[] = Object.getOwnPropertySymbols(
  FORTNITE_QUEUES,
)
  .map((q) => FORTNITE_QUEUES[q].backendKey)
  .filter((q) => q) as string[];

export const getBEModeFromGameMode = (gameMode: string) => {
  const queue = Object.getOwnPropertySymbols(FORTNITE_QUEUES).find((s) =>
    FORTNITE_QUEUES[s]?.internal?.includes(gameMode),
  );
  return (
    FORTNITE_QUEUES[queue!]?.backendKey ??
    FORTNITE_QUEUES_BE.find((i) => new RegExp(i, "i").test(gameMode)) ??
    gameMode
  );
};

export const isSoloMode = (gameMode: string) => {
  return (
    gameMode === FORTNITE_QUEUES[FORTNITE_QUEUES_SYMBOLS.solo].key ||
    gameMode === FORTNITE_QUEUES[FORTNITE_QUEUES_SYMBOLS.ogSolo].key ||
    gameMode === FORTNITE_QUEUES[FORTNITE_QUEUES_SYMBOLS.reloadSolo].key
  );
};
